import { AppScreens } from '@/shared/types';
import { RouteRecordRaw } from 'vue-router';

export const storiesRoute: RouteRecordRaw = {
  path: `/interactive-bible`,
  name: AppScreens.InteractiveBible,
  component: () => import('@/modules/interactive-experience/views/InteractiveBible.vue'),
  meta: {
    layout: 'main',
  },
};

export const storiesRoadmapRoute: RouteRecordRaw = {
  path: `/interactive-bible/:roadmapId`,
  name: 'InteractiveBibleRoadmap',
  component: () => import('@/modules/interactive-experience/views/InteractiveBible.vue'),
  props: true,
  meta: {
    layout: 'main',
  },
};// Routes moved to StoriesModule
